import { any } from 'prop-types'
import { Fragment } from 'react'
const LayoutWrapper = ({ children }) => {
	return <Fragment>{children}</Fragment>
}
LayoutWrapper.propTypes = {
	children: any,
}
export default LayoutWrapper
